
import { Box, Card, Typography } from "@mui/material";
import ListaVazia from "../../utils/listaVazia";
import ObservacoesFeitas from "../departamentos/dlif/observacoesFeitas";
import EncaminhaExpediente from "./encaminhaExpediente";

export default function NavLateral({ expediente, setUpdate, observacoesFeitas }) {

  return (
    <>
      <Card style={{ padding: 20 }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/expediente/entrada.svg" alt="img" width={'100%'} />
        </div>

        <Typography m align="center">
          Estado do expediente
          <br />
          <b>Em {expediente.status} </b>
        </Typography>
        {/* <StatusEstabelecimento status={expediente.status} /> */}

        <Box>
          <br />
          {expediente?.status !== "Finalizado" ? (
            <EncaminhaExpediente
              expediente={expediente}
              setUpdate={setUpdate}
            />
          ) : (
            <ListaVazia text={"Processo já análisado!"} />
          )}
        </Box>
      </Card>

      {observacoesFeitas?.length > 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}
    </>
  );
}
